
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M17 1C8.177 1 1 8.178 1 17s7.177 16 16 16 16-7.177 16-16S25.823 1 17 1zm0 29.091C9.782 30.091 3.909 24.219 3.909 17 3.909 9.782 9.782 3.909 17 3.909S30.091 9.782 30.091 17c0 7.219-5.873 13.091-13.091 13.091z"}}),_c('path',{attrs:{"d":"M16.681 21.879c-.981 0-1.776.771-1.776 1.723 0 .951.795 1.723 1.776 1.723.982 0 1.777-.771 1.777-1.723 0-.951-.796-1.723-1.777-1.723zm0-13.606c-1.428 0-2.59 1.127-2.59 2.512 0 .883.992 6.618 1.475 8.711a.417.417 0 00.409.318h1.413a.417.417 0 00.409-.318c.482-2.093 1.475-7.828 1.475-8.711-.001-1.386-1.163-2.512-2.591-2.512z"}})])])
          )
        }
      }
    